import styled from "styled-components";
import { Box, BoxProps } from "@xcorejs/ui";

const TableBodyStyle = styled(Box)``;

const TableBody = ({ children, ...props }: BoxProps) => {
  return (
    <TableBodyStyle as="tbody" {...props}>
      {children}
    </TableBodyStyle>
  );
};

export default TableBody;
